import React from 'react';
import PropTypes from 'prop-types';
import { RxCheck } from "@react-icons/all-files/rx/RxCheck";
import { Button } from 'day8-ui';
import { FaCircleInfo } from "@react-icons/all-files/fa6/FaCircleInfo";
import { useToolipModal } from '../../context/TooltipModalContext';
// import moment from 'moment';

const FreeCancellation = ({
  className,
  bookingId
  // firstDeadline,
  // bookingDate
}) => {
  const { openTooltipModal } = useToolipModal();
  // const firstDeadlineDays = firstDeadline?.date && moment(firstDeadline.date).diff(moment(bookingDate).startOf('day'), 'days');
  // const cancellationPeriod = firstDeadlineDays > 1 ? '48 hour' : '24 hour';
  const cancellationPeriod = '24 hour';
  return (
    <div className={className}>
      <h3 className='dui-text-2xl'>Payment information</h3>
      <div className='dui-mt-4 dui-flex dui-items-center dui-justify-between dui-gap-4 dui-font-semibold'>
        <Button
          buttonType='LINK_UNDERLINE'
          buttonSize="MEDIUM"
          rightIcon={<FaCircleInfo />}
          onClick={() => openTooltipModal({ title: `Free ${cancellationPeriod} cancellation`, tooltipText: `Free cancellation applies only within ${cancellationPeriod} of paying the deposit.` })}
        >
          Free {cancellationPeriod} cancellation
        </Button>
        <RxCheck />
      </div>
      <div className='dui-mt-4 dui-flex dui-items-center dui-justify-between dui-gap-4 dui-font-semibold'>
        <Button
          buttonType='LINK_UNDERLINE'
          buttonSize="MEDIUM"
          rightIcon={<FaCircleInfo />}
          onClick={() => openTooltipModal({ title: 'Split with friends', tooltipText: "To help you share the cost between your crew mates, get your lead booker to complete the deposit payment and then invite your crew to pay their share towards the booking." })}
        >
          Split with friends
        </Button>
        <RxCheck />
      </div>
      <div className='dui-mt-4 dui-flex dui-items-center dui-justify-between dui-gap-4 dui-font-semibold'>
        <Button
          buttonType='LINK_UNDERLINE'
          buttonSize="MEDIUM"
          rightIcon={<FaCircleInfo />}
          onClick={() => openTooltipModal({ title: 'Credit Card Fees', tooltipText: "Just a heads up – certain cards may have a processing fee. For more info head to our Payment FAQs." })}
        >
          Credit Card Fees
        </Button>
      </div>
      {bookingId && (
        <div className='dui-mt-4 dui-font-semibold'>
          <Button
            buttonType='LINK_UNDERLINE'
            buttonSize="MEDIUM"
            onClick={() => window.open(`/api/account/booking/${bookingId}.pdf`, '_blank', 'noopener,noreferrer')}
          >
            Download booking confirmation
          </Button>
        </div>
      )}
    </div>
  );
};

FreeCancellation.propTypes = {
  className: PropTypes.string,
  bookingId: PropTypes.number,
  destinationId: PropTypes.number,
  freeCancellation: PropTypes.bool,
  ignoreFreeCancellationCutoff: PropTypes.bool
};

FreeCancellation.defaultProps = {
  freeCancellation: false,
  ignoreFreeCancellationCutoff: false
};

export default FreeCancellation;
